// extracted by mini-css-extract-plugin
export default {"heading":"Advantages_heading__tefwH","ul":"Advantages_ul__-e73y","li":"Advantages_li__RWFd1","number":"Advantages_number__JDhwX"};